/* Profile Controller
 ** Author: Soc-dfsk -30
 ** Version: 1.0
 ** Date 10/01/2017 */
'use strict';
var customTimeout;
App.controller('ProfileCtrl', ['$window', '$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout',
    'toastr', 'Api', '$log', '$localStorage', '$filter', 'commonService',
    '$uibModal', '$loading', '$document', '$state', '$sessionStorage', 'offsetDST', 'fileDownload', 'base64ToImage',
    'getOS', 'authApi', 'briefcaseService', 'briefcaseConstants', 'sessionService',
    function ($window, $rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, toastr,
        Api, $log, $localStorage, $filter, commonService, $uibModal, $loading, $document, $state,
        $sessionStorage, offsetDST, fileDownload, base64ToImage, getOS, authApi, briefcaseService, briefcaseConstants, sessionService) {

        $scope.nameRegex = /^[a-zA-Z- `~:;'",.“”‘’‛‟‚„′″´˝]*$/;
        $scope.user = {};
        $scope.myprofileSubmitted = false;
        $scope.preChecked = false;
        $scope.user.edithide = true;
        $scope.logoImage = $localStorage.logoImage;
        $scope.$parent.logoImage = $localStorage.logoImage;
        briefcaseConstants.ACCESS_TOKEN = $localStorage['token'];
        $scope.showProgressOverview = false;
        const briefcaseTabs = [
            'dashboard.profile',
            'dashboard.license',
            'dashboard.education',
            'dashboard.tasks',
            'dashboard.documents'
        ];
        
        const index = briefcaseTabs.indexOf($state.current.name);
        if(index >= 0){
            briefcaseService.redirectionFlag = index;
        }

        $scope.profileCheckbox = [
            {
                "label": "Account Details",
                "checked": true,
                "requires": [],
            },
            {
                "label": "My Profile",
                "checked": false,
                "requires": ['firstName', 'lastName', 'phoneNumber', 'email', 'address'],
            },
            {
                "label": "Licenses & Certifications",
                "checked": false,
                "requires": ['briefcase.licenses', 'briefcase.currentStep'],
                "value": 2
            },
            {
                "label": "Education & Work Experience",
                "checked": false,
                "requires": [['briefcase.workExperience.resumeFileId', 'briefcase.workExperience.resumeFileUrl'], 'briefcase.yearsOfExperience', 'briefcase.references', 'briefcase.currentStep'],
								"value": 3
            }
        ];
        
        this.updateData = (userData) => {
            if (userData) {
                $scope.user.currentStep = 0;
                $scope.user.firstName = userData.firstName;
                $scope.user.lastName = userData.lastName;
                $scope.user.email = userData.email;
                $scope.user.phoneNumber = userData.phoneNumber;
                briefcaseService.briefcaseSession = userData;
                briefcaseService.briefcase.id = _.get(userData, '_id');
                $scope.profileCheckbox.forEach((c) => c.checked = c.requires.every((p) => {
                    const checks = Array.isArray(p) ? p : [p];

                    return checks.some(item => {
                        if (item === 'briefcase.currentStep') {
                            return c.value <= _.get(userData, item);
                        }
    
                        return _.get(userData, item);
                     });
                }));

                const step = _.get(userData, 'briefcase.currentStep', 0);
                if (step < 1) {
                    briefcaseService.redirectionFlag = 0;
                }

                if(!$scope.$$phase){
                    $scope.$apply();   
                }
            }
        }

        if (window.innerWidth >= 600) {
            $scope.showProgressOverview = true
        }

        $scope.subscription = sessionService.professionalData.subscribe(this.updateData.bind(this));
        $scope.$on('$destroy', $scope.subscription);
        
        $scope.$on('briefcaseTabChangeEventForNurse', function (event, {flag}) {
            const newPath = briefcaseTabs[flag];

            if(window.innerWidth >= 600){
                $scope.showProgressOverview = true
            } else {
                $scope.showProgressOverview = false
            }
            
            newPath && updateUrlPath(newPath);
        });

        function updateUrlPath(newState) {
            $state.go(newState, {id: null}, {
                location: true,
                inherit: true,
                relative: $state.$current,
                notify: false
            });
        }
    }
]);


